import { createFileRoute, redirect } from "@tanstack/react-router";

import { isAdminRole } from "@/auth/shared";
import { VenuesList } from "@/components/admin/venues-list";
import { DefaultLayout } from "@/layouts/default";

export const Route = createFileRoute("/admin/venues")({
  loader: async ({ context: { viewer } }) => {
    if (!viewer || !isAdminRole(viewer.role)) {
      throw redirect({ to: "/not-found" });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DefaultLayout
      classNames={{
        content: "max-w-4xl px-4 py-16 mx-auto flex flex-col space-y-8",
      }}
    >
      <VenuesList />
    </DefaultLayout>
  );
}
